import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export function mapDecisionTypeFromApi(d) {
  return {
    id: d.id,
    name: d.name ?? '',
    description: d.description ?? '',
    createdAt: d.createdAt ? String(d.createdAt).slice(0, 10) : '',
    branchId: d.companyId,
    branch: d.companyName ?? '',
    status: d.isActive ? 'active' : 'inactive',
  };
}

export function mapDecisionTypeFormToPayload(form) {
  return {
    name: form.name?.trim() ?? '',
    description: form.description?.trim() || null,
    companyId: Number(form.branchId),
    isActive: form.status === 'active',
  };
}

export async function fetchDecisionTypes() {
  const res = await fetch(`${API_BASE}/api/decisiontypes`, { headers: { Accept: 'application/json', ...authHeaders() } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل أنواع القرارات'));
  const list = Array.isArray(data) ? data : [];
  return list.map(mapDecisionTypeFromApi);
}

export async function fetchDecisionTypeById(id) {
  const res = await fetch(`${API_BASE}/api/decisiontypes/${id}/detail`, { headers: { Accept: 'application/json', ...authHeaders() } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل نوع القرار'));
  return mapDecisionTypeFromApi(data);
}

export async function createDecisionType(payload) {
  const res = await fetch(`${API_BASE}/api/decisiontypes`, { method: 'POST', headers: jsonHeaders(), body: JSON.stringify(payload) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة النوع'));
  return mapDecisionTypeFromApi(data);
}

export async function updateDecisionType(id, payload) {
  const res = await fetch(`${API_BASE}/api/decisiontypes/${id}/edit`, { method: 'PUT', headers: jsonHeaders(), body: JSON.stringify(payload) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ التعديلات'));
  return mapDecisionTypeFromApi(data);
}

export async function deleteDecisionType(id) {
  const res = await fetch(`${API_BASE}/api/decisiontypes/${id}`, { method: 'DELETE', headers: { Accept: 'application/json', ...authHeaders() } });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر حذف النوع'));
}
